import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DashboardService from '../../../core/service'

export const getMostPopular = createAsyncThunk(
  'dashboard/recentlyAndPopular/getMostPopular',
  async (prams, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getMostPopular(prams)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getRecentlyViewed = createAsyncThunk(
  'dashboard/recentlyAndPopular/getRecentlyViewed',
  async (prams, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getRecentlyViewed(prams)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
